var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50065 3.5V10.3833C2.50065 11.0367 2.50065 11.3632 2.62781 11.6128C2.73966 11.8323 2.91801 12.0111 3.13753 12.123C3.38685 12.25 3.7134 12.25 4.36552 12.25H7.63579C8.2879 12.25 8.61398 12.25 8.8633 12.123C9.08282 12.0111 9.26176 11.8323 9.37362 11.6128C9.50065 11.3634 9.50065 11.0373 9.50065 10.3851V3.5M2.50065 3.5H3.66732M2.50065 3.5H1.33398M3.66732 3.5H8.33398M3.66732 3.5C3.66732 2.9564 3.66732 2.68474 3.75612 2.47034C3.87453 2.18447 4.1015 1.95722 4.38737 1.83881C4.60177 1.75 4.87372 1.75 5.41732 1.75H6.58398C7.12758 1.75 7.39938 1.75 7.61378 1.83881C7.89965 1.95722 8.12671 2.18447 8.24512 2.47034C8.33392 2.68474 8.33398 2.9564 8.33398 3.5M8.33398 3.5H9.50065M9.50065 3.5H10.6673",
    stroke: "#232F6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.4e2ef5d24c9d90fda6b0ad33bc064943.svg";
export { ForwardRef as ReactComponent };